import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { DashboardLayoutComponent } from "@syncfusion/ej2-react-layouts";
import { TreeViewComponent } from "@syncfusion/ej2-react-navigations";
import { DASHBOARD_WIDGETS } from "./DashboardWidgets";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import "./styles/Settings.css";

function SettingsDashboardSetup(props) {
  let panels = [];

  const hierarchicalData = useRef(DASHBOARD_WIDGETS);
  const [displayPage, setDisplayPage] = useState(null);

  const dashboardSetupObj = useRef();
  const treeViewRef = useRef();
  const fields = {
    dataSource: hierarchicalData.current,
    id: "id",
    text: "text",
    child: "subChild",
  };
  const [allowDragging, setAllowDragging] = useState(true);
  const [placedIds, setPlacedIds] = useState([]);
  const expNodes = useRef();
  const dragButtonClass = useRef("settingsButtonActive");
  // used to be OpenWithIcon below
  const dragButtonIcon = useRef("Switch to panel removal mode");

  placedIds.forEach((elem) => {
    const imgElem = document.getElementById(elem);
    if (imgElem) {
      imgElem.addEventListener("contextmenu", (event) => {
        console.log("here");
        event.preventDefault();
      });
    }
  });

  //  useEffect(() => {
  const panelRestoreString = sessionStorage.getItem("dashboardRestore");
  if (panelRestoreString) {
    const panelRestore = JSON.parse(panelRestoreString);
    for (let i = 0; i < panelRestore.length; i++) {
      const widget = getNode(
        panelRestore[i].id.substring(0, panelRestore[i].id.length - 7),
        hierarchicalData.current,
      );
      panelRestore[i].content =
        '<div class="positionRelative"><img id="' +
        panelRestore[i].id +
        '_img" src="' +
        widget.image +
        '" style="height:80px;max-width:100%;"><div class="settingsDashSetupTextOnImageLeft">' +
        widget.text +
        '</div><div class="settingsDashSetupTextOnImageRight"></div></div>';

      //setPlacedIds([...placedIds, panelRestore[i].id + "_img"]);
    }
    panels = panelRestore;
  }
  // }, []);

  const handleExpansion = () => {
    expNodes.current = treeViewRef.current.expandedNodes;
  };

  const addWidget = (event) => {
    let brakes = 0;
    let checkElement = event.target;
    while (checkElement.id == "" && brakes < 10) {
      checkElement = checkElement.parentElement;
    }
    const widgetId = checkElement.id;
    const widgetIdLayout = widgetId + "_layout";

    // check if widget already in setup
    let widgetIndex = -1;
    if (
      dashboardSetupObj.current &&
      dashboardSetupObj.current.gridPanelCollection.length > 0
    ) {
      widgetIndex = dashboardSetupObj.current.gridPanelCollection.findIndex(
        (panel) => {
          return panel.id == widgetIdLayout;
        },
      );
    }
    if (widgetIndex == -1) {
      const widget = getNode(widgetId, hierarchicalData.current);

      const contentValue =
        '<div class="positionRelative"><img id="' +
        widgetId +
        '_img" src="' +
        widget.image +
        '" style="height:80px;max-width:100%;"><div class="settingsDashSetupTextOnImageLeft">' +
        widget.text +
        '</div><div class="settingsDashSetupTextOnImageRight" onClick="alert(\'foo\')"></div></div>';

      let panel = [
        {
          id: widgetId + "_layout",
          sizeX: widget.size,
          sizeY: 1,
          row: 8,
          col: 0,
          content: contentValue,
        },
      ];
      dashboardSetupObj.current.addPanel(panel[0]);

      //console.log({ treeViewRef });
      setPlacedIds([...placedIds, widgetId]);
      saveSettings();
    }
  };

  /* const removeWidget = (event) => {
    let brakes = 0;
    let checkElement = event.target;
    while (checkElement.id == "" && brakes < 10) {
      checkElement = checkElement.parentElement;
    }

    dashboardSetupObj.current.removePanel(checkElement.id + "_layout");

    const newPlacedIds = JSON.parse(JSON.stringify(placedIds));

    const indexToRemove = newPlacedIds.indexOf(checkElement.id);
    newPlacedIds.splice(indexToRemove, 1);
    setPlacedIds(newPlacedIds);

    //dashboardSetupObj.current.removePanel(event.element.id);
  };*/
  /*const onDragStop = (event) => {
    if (event.element.dataset.row > 3) {
      panelToRemove.current = event.element.id.substring(
        0,
        event.element.id.length - 7,
      );

      const newPlacedIds = JSON.parse(JSON.stringify(placedIds));
      const indexToRemove = newPlacedIds.indexOf(panelToRemove.current);
      newPlacedIds.splice(indexToRemove, 1);
      setPlacedIds(newPlacedIds);

      //dashboardSetupObj.current.removePanel(event.element.id);
    }
  };

  const onDragStart = (event) => {
    console.log("dragstart");
  };*/

  /*useEffect(() => {
    if (panelToRemove.current) {
      dashboardSetupObj.current.removePanel(panelToRemove.current);
      panelToRemove.current = null;
    }
  }, [panelToRemove.current]);*/

  function getNode(nodeId, parentArray) {
    let returnVal;
    for (let i = 0; i < parentArray.length; i++) {
      if (parentArray[i].id == nodeId) {
        returnVal = parentArray[i];
      } else if (parentArray[i].subChild) {
        returnVal = getNode(nodeId, parentArray[i].subChild);
      }
      if (returnVal) {
        break;
      }
    }
    return returnVal;
  }

  function listNodeTemplate(data) {
    let boxWidthInteger = 100;
    switch (data.id.length) {
      case 2:
        boxWidthInteger = 260;
        break;
      case 5:
        boxWidthInteger = 236;
        break;
      case 8:
        boxWidthInteger = 212;
        break;
    }

    const boxWidth = boxWidthInteger + "px";

    let divClassName =
      data.id.length == 2 && data.subChild
        ? "settingsDashSetupParent"
        : data.id.length == 5 && data.subChild
          ? "settingsDashSetupSubParent"
          : "settingsDashSetupChild";

    if (placedIds.find((elem) => elem == data.id)) {
      divClassName += " settingsDashSetupPlaced";
    }

    if (dashboardSetupObj.current) {
      if (
        dashboardSetupObj.current.gridPanelCollection.find(
          (elem) => elem.id.substring(0, elem.id.indexOf("_")) == data.id,
        )
      ) {
        divClassName += " settingsDashSetupPlaced";
      }
    }
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: boxWidth,
          overflow: "hidden",
        }}
      >
        <div className={divClassName}>{data.text}</div>
        {divClassName == "settingsDashSetupChild" ? (
          <AddIcon id={data.id} onClick={addWidget} />
        ) : null}
      </Box>
    );
  }

  function saveSettings() {
    const setupModel = dashboardSetupObj.current.serialize();
    sessionStorage.setItem("dashboardRestore", JSON.stringify(setupModel));
    let tempNode;
    let rowArray = [];
    if (setupModel && setupModel.length > 0) {
      for (let i = 0; i < setupModel.length - 1; i++) {
        for (let j = i + 1; j < setupModel.length; j++) {
          const iValue = setupModel[i].row * 12 + setupModel[i].col;
          const jValue = setupModel[j].row * 12 + setupModel[j].col;

          if (iValue > jValue) {
            tempNode = setupModel[i];
            setupModel[i] = setupModel[j];
            setupModel[j] = tempNode;
          }
        }
      }

      const maxRow = setupModel[setupModel.length - 1].row;

      for (let rowNum = 0; rowNum <= maxRow; rowNum++) {
        let colArray = [];
        let colNum = 0;
        while (colNum < 12) {
          const foundCell = setupModel.find(
            (elem) => elem.row == rowNum && elem.col == colNum,
          );

          if (foundCell) {
            const widgetId = foundCell.id.substring(0, foundCell.id.length - 7);
            const widget = getNode(widgetId, hierarchicalData.current);
            colArray.push({
              component: widget.text,
              id: widgetId,
              size: foundCell.sizeX,
            });
            colNum += foundCell.sizeX;
          } else {
            colArray.push({ component: null, id: null, size: 1 });
            colNum++;
          }
        }
        rowArray.push(colArray);
      }
    }

    sessionStorage.setItem("dashboardSetup", JSON.stringify(rowArray));
    //props.handleSettingsChange(null, "Dashboard");
  }

  const handleLayoutClick = (event) => {
    if (!allowDragging) {
      let panelId = event.target.id.substring(0, event.target.id.length - 4);
      if (panelId.indexOf("_layout") == -1) {
        panelId += "_layout";
      }
      dashboardSetupObj.current.removePanel(panelId);
      saveSettings();
    }
  };

  const handleAllowDragging = () => {
    dragButtonClass.current = allowDragging
      ? "settingsButtonInactive"
      : "settingsButtonActive";
    // second DeleteIcon below used to be OpenWithIcon
    //dragButtonIcon.current = allowDragging ? <DeleteIcon /> : <DeleteIcon />;
    dragButtonIcon.current = allowDragging
      ? "Switch to panel placement mode"
      : "Switch to panel removal mode";
    props.setLock(allowDragging);
    setAllowDragging(!allowDragging);
  };

  useEffect(() => {
    const prepPageDisplay = (
      <Fragment>
        <Box display="flex" alignItems="flex-start" alignContent="flex-start">
          <Box>
            <Box
              width="350px"
              height="600px"
              sx={{
                border: "solid 5px",
                backgroundColor: "silver",
                borderRadius: "20px",
                borderColor: "#643f69",
                paddingTop: "20px",
              }}
            >
              <TreeViewComponent
                fields={fields}
                nodeTemplate={listNodeTemplate}
                ref={(tvc) => (treeViewRef.current = tvc)}
                nodeExpanded={handleExpansion}
                expandedNodes={expNodes.current}
              />
            </Box>
          </Box>
          <Box display="inline">
            <Box
              display="flex"
              justifyContent="center"
              className={dragButtonClass.current + "_box"}
            >
              <Button
                variant="contained"
                onClick={handleAllowDragging}
                className={dragButtonClass.current}
              >
                {dragButtonIcon.current}
              </Button>
            </Box>
            <Box
              width="610px"
              height="460px"
              className={dragButtonClass.current + "_layoutbox"}
            >
              <DashboardLayoutComponent
                allowDragging={allowDragging}
                onClick={handleLayoutClick}
                id="defaultLayout"
                panels={panels}
                columns={12}
                cellAspectRatio={100 / 200}
                ref={(dlc) => (dashboardSetupObj.current = dlc)}
                dragStop={saveSettings}
              />
            </Box>
          </Box>
        </Box>
      </Fragment>
    );
    setDisplayPage(prepPageDisplay);
  }, [hierarchicalData.current, placedIds, expNodes.current, allowDragging]);

  return displayPage;
}

export default SettingsDashboardSetup;

SettingsDashboardSetup.propTypes = {
  handleSettingsChange: PropTypes.func,
  id: PropTypes.string,
};

/*

              <Button
                variant="contained"
                onClick={saveSettings}
                className={dragButtonClass.current}
              >
                Save Setup
              </Button>
              */
